import BaseService from './base';
import request from '@/utils/request';

export interface FileViewModel {
  id?: string;
  courseID?: number;
  bookID?: number;
  courseStructID?: number;
  userID?: string;
  resID?: string;
  sourceFileName?: string;
  aliasName?: string;
  serverFolder?: string;
  serverFileName?: string;
  size?: number;
  unit?: string;
  fileType?: number;
  mime?: string;
  displayName?: string;
  fullName?: string;
  timelineItemIDs?: any[];
  isPublic?: number;
  thumb?: string;
  mediaLength?: number;
}

export default class FileService extends BaseService<FileViewModel> {
  protected serviceApi: string = 'File';

  get NewModel(): FileViewModel {
    return {
      resID: '',
      courseID: 0,
      courseStructID: 0,
      timelineItemIDs: [],
      isPublic: 1,
      mediaLength: 0,
    };
  }

  // public Search(data: FileViewModel) {
  //   return request({
  //     url: this.serviceApi + this.searchApi + '/',
  //     method: 'post',
  //     data: data,
  //   });
  // }

  public UpdateAlias(id: number, aliasName: string) {
    return request({
      url: `${this.serviceApi}/UpdateAlias`,
      method: 'put',
      data: {id: id, aliasName: aliasName},
    });
  }

  public CreateBatch(files: FileViewModel[]) {
    return request({
      url: `${this.serviceApi}/CreateBatch`,
      method: 'post',
      data: files,
    });
  }
  public GetTimelineItem(id: string) {
    return request({
      url: `${this.serviceApi}/GetTimelineItem/${id}`,
      method: 'get',
    });
  }
  public GetByTimeline(id: number, count: number) {
    return request({
      url: `${this.serviceApi}/GetByTimeline/${id}/${count}`,
      method: 'get',
    });
  }

  public UpdateTimelineItem(data: FileViewModel) {
    return request({
      url: `${this.serviceApi}/UpdateTimelineItem`,
      method: 'put',
      data: data,
    });
  }

  public signatureUrl(id: string) {
    return request({
      url: `${this.serviceApi}/signatureUrl/${id}`,
      method: 'get',
    });
  }

  public signaturePreviewUrl(id: string) {
    return request({
      url: `${this.serviceApi}/signaturePreviewUrl/${id}`,
      method: 'get',
    });
  }
}
